export enum AdsType {
  mid = 'mid',
  pre = 'pre',
}

export enum VideoQuality {
  Q1080p = 1,
  Q720p = 2,
  Q480p = 3,
  Q360p = 4,
}

export enum Reaction {
  like = 1,
  dislike = 2,
}

export enum PlaybackType {
  preview = 'PREVIEW',
  film = 'FILM',
  clip = 'CLIP',
}

export enum URLType {
  film = 'Film',
  teaser = 'Teaser',
  trailer = 'Trailer',
  subtitle = 'Subtitle',
}

export enum MovieStatus {
  draft = 'Draft',
  submit = 'Submit',
}

export enum QuestionType {
  MCQ = 'MCQ', // Multiple Choice Questions
  MSQ = 'MSQ', // Multiple Select Questions
  TEXT = 'TEXT', // Open-ended text questions
  LONG = 'LONG', // Long text questions
}

export enum SurveyType {
  CONTENT_FEEDBACK = 'CONTENT_FEEDBACK', // Feedback on the movie/show content itself
  USER_EXPERIENCE = 'USER_EXPERIENCE', // Questions about the platform's usability or experience
  ENGAGEMENT_TRACKING = 'ENGAGEMENT_TRACKING', // Track viewer attention, interest, and engagement
  AD_FEEDBACK = 'AD_FEEDBACK', // Feedback on advertisements shown during playback
  PERSONALIZATION = 'PERSONALIZATION', // Questions to improve recommendation algorithms
  TECHNICAL_ISSUE = 'TECHNICAL_ISSUE', // For reporting buffering, playback, or audio/video issues
  BEHAVIORAL_INSIGHT = 'BEHAVIORAL_INSIGHT', // Why the user watched, stopped, or skipped content
}
